import { usePreferencesStore } from '@/stores/preferences.store';
import { useMe } from '@/stores/session.store';

export type CurrentShop = {
  /** La boutique sur laquelle l'espace pro travaille, ou `undefined` sans boutique. */
  shopId: string | undefined;
  /** Toutes les boutiques que le compte opère : les siennes, puis celles où il aide. */
  operated: Array<string>;
  /** Le compte en est le responsable, et non un aide vendeur. */
  owned: boolean;
  choose: (shopId: string) => void;
};

/**
 * La boutique courante de l'espace pro.
 *
 * Un compte peut en opérer plusieurs. Chaque écran lisait alors la sienne à sa
 * façon (« la première possédée », « celle de la route ») : le tableau de bord
 * montrait une boutique, les finances une autre, et un compte de paiement
 * s'ajoutait à la mauvaise. Tous les écrans du mode pro lisent désormais la
 * même, choisie une fois et retrouvée au lancement suivant.
 *
 * `requested` : une boutique demandée par la route (« Tableau de bord » depuis
 * une fiche) l'emporte le temps de l'écran, si le compte l'opère.
 */
export function useCurrentShop(requested?: string): CurrentShop {
  const me = useMe();
  const chosen = usePreferencesStore((state) => state.currentShopId);
  const choose = usePreferencesStore((state) => state.setCurrentShop);

  const ownedIds = me?.ownedShopIds ?? [];
  const operated = [...new Set([...ownedIds, ...(me?.memberShopIds ?? [])])];
  const shopId = [requested, chosen].find((id) => id && operated.includes(id)) ?? operated[0];

  return {
    shopId,
    operated,
    owned: shopId !== undefined && ownedIds.includes(shopId),
    choose,
  };
}
